/**
 *
 * ResubscribeMessage
 *
 * The words a canceled-subscription account is shown when it reaches for
 * channel creation or editing. Two surfaces render it — the modal that opens
 * from a blocked control (`components/ResubscribeModal`) and the inline notice
 * that replaces the form on a deep link (`components/SubscriptionRequiredNotice`)
 * — so it lives here rather than being written twice: the two must not drift,
 * because a user who clicks New Channel and a user who pastes /channels/new are
 * in the same situation and deserve the same answer.
 *
 * There is no self-serve reactivation to link to (the Memento checkout was
 * removed — see PlanSelectionModal), so the CTA is a mailto to the help@
 * role address (account and support mail; it replaced pip@ on 2026-11-02). Intercom is the faster path for
 * anyone who has it loaded, but it is a third-party script; the mailto works
 * with an ad-blocker, an outage, or no network to Intercom at all.
 *
 * The last sentence is deliberate. Being blocked from editing reads like data
 * loss, and it is not: nothing is deleted when a subscription lapses.
 */
import React from 'react';
import { ContactLink, Text } from './styledComponents';
import H1 from 'components/H1';

const ResubscribeMessage = () => (
  <>
    <H1>Your subscription has ended</H1>
    <Text>
      Creating and editing channels needs an active subscription. Email{' '}
      <ContactLink
        href="mailto:help@movebooth.com?&subject=Movebooth%20Resubscribe%20Request&body=I'd like to reactivate my subscription."
      >
        help@movebooth.com
      </ContactLink>{' '}
      and we'll get you set up again. Your channels, galleries, and leads are
      untouched and waiting.
    </Text>
  </>
);

export default ResubscribeMessage;
